"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActivityGoalsSchema = void 0;
const core_1 = require("@zodios/core");
const zod_1 = __importDefault(require("zod"));
const activity_unstructured_1 = require("../core/activity.unstructured");
exports.getActivityGoalsSchema = (0, core_1.makeEndpoint)({
    method: "get",
    path: "/app/activity/goals/:userActivityId",
    alias: "getActivityGoals",
    parameters: [],
    response: zod_1.default.array(activity_unstructured_1.goalSchema),
});
//# sourceMappingURL=getActivityGoals.js.map